export const formatCurrency = (amount: number): string =>
    `$${amount.toLocaleString('en-US', { maximumFractionDigits: 0, minimumFractionDigits: 0 })}`;
